export const RESTAURANT_GROUP_BUTTON_TEXT = 'RESTAURANT_GROUP_BUTTON_TEXT';
export const RESTAURANT_GROUP_DESCRIPTION = 'RESTAURANT_GROUP_DESCRIPTION';

export type AppTexts = Record<string, Record<string, string>>;

export function resolveRestaurantText(
  appTexts: AppTexts | undefined,
  lang: string,
  key: string,
  fallback: string,
): string {
  const value = appTexts?.[lang]?.[key];
  return value ? value : fallback;
}
